<template>
  <breadcrumb :links="{'/': 'Home', 'current': 'Attribuzioni'}"></breadcrumb>

  <div>
    <div class="section section_odd">
      <div class="container-xl">
        <h1>Attribuzioni</h1>
        <p>
          Per la costruzione di questo sito sono state utilizzate diverse risorse open source.
        </p>
      </div>
    </div>
    <div class="section section_even">
      <div class="container-xl">
        <h2>Dati da OpenStreetMap</h2>
        <p>Le mappe di sfondo utilizzano dati del progetto OpenStreetMap rilasciati con licenza ODbL.</p>
      </div>
    </div>
    <div class="section section_odd">
      <div class="container-xl">
        <h2>Bootstrap</h2>
        <p>Il tema e le icone sono prodotti dal progetto Bootstrap e rilasciati con licenza MIT.</p>
      </div>
    </div>
    <div class="section section_even">
      <div class="container-xl">
        <h2>Chart.js</h2>
        <p>I grafici sono realizzati utilizzando la libreria Chart.js rilasciata con licenza MIT.</p>
      </div>
    </div>
    <div class="section section_odd">
      <div class="container-xl">
        <h2>OpenLayers</h2>
        <p>La gestione delle mappe è affidata alla libreria OpenLayers.</p>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</template>

<script>
  import AppFooter from '@/app-footer.vue'
  import Breadcrumb from '@/components/Breadcrumb'

  export default {
    components: {AppFooter, Breadcrumb}
  }
</script>

<style lang="scss" scoped>
  .section {
    padding-top: 20px;
    min-height: 150px;
  }
</style>